/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * shortsworks
 * 

#ShortsWorksAPIDocs

##버전

헤더에그룹화된태그를추가하는방식으로버저닝을지원합니다.

예시)
```

GET{{host}}/account/signin
headers=[
...
{"x-api-version":"2024-09-01"},
...
]

```

버전리스트
***2024-09-01**(version을적지않으면기본적용되는버전)
***2024-10-16**


 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CommonResponseDto,
  ConcatStoryRequestDto,
  DeleteStoriesParams,
  GetStoriesByIdsParams,
  GetStoriesCountParams,
  GetStoriesParams,
  GetStoryParams,
  HTTPValidationError,
  StoriesMetaUpdateRequestDto,
  StoriesResponseDto,
  StoryMetaUpdateRequestDto,
  StoryRegistryRequestDto,
  StoryResponseDto,
  StoryUpdateRequestDto
} from '.././model'
import { client } from '../../lib/client';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 조건에따라포스팅리스트를불러오는API
 * @summary GetStories
 */
export const getStories = (
    params?: GetStoriesParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<StoriesResponseDto>(
      {url: `/stories/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetStoriesQueryKey = (params?: GetStoriesParams,) => {
    return [`/stories/`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStoriesQueryOptions = <TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(params?: GetStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStories>>> = ({ signal }) => getStories(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getStories>>>
export type GetStoriesQueryError = HTTPValidationError


export function useGetStories<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params: undefined |  GetStoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStories>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStories<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params?: GetStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStories>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStories<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params?: GetStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStories
 */

export function useGetStories<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params?: GetStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(params?: GetStoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStories>>> = ({ signal }) => getStories(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStories>>>
export type GetStoriesSuspenseQueryError = HTTPValidationError


export function useGetStoriesSuspense<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params: undefined |  GetStoriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesSuspense<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params?: GetStoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesSuspense<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params?: GetStoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStories
 */

export function useGetStoriesSuspense<TData = Awaited<ReturnType<typeof getStories>>, TError = HTTPValidationError>(
 params?: GetStoriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStories>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 여러개의포스팅의메타데이터를한번에변경하는API
 * @summary UpdateStoriesMetadata
 */
export const updateStoriesMetadata = (
    storiesMetaUpdateRequestDto: StoriesMetaUpdateRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: storiesMetaUpdateRequestDto
    },
      options);
    }
  


export const getUpdateStoriesMetadataMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoriesMetadata>>, TError,{data: StoriesMetaUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoriesMetadata>>, TError,{data: StoriesMetaUpdateRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoriesMetadata>>, {data: StoriesMetaUpdateRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateStoriesMetadata(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoriesMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoriesMetadata>>>
    export type UpdateStoriesMetadataMutationBody = StoriesMetaUpdateRequestDto
    export type UpdateStoriesMetadataMutationError = HTTPValidationError

    /**
 * @summary UpdateStoriesMetadata
 */
export const useUpdateStoriesMetadata = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoriesMetadata>>, TError,{data: StoriesMetaUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateStoriesMetadata>>,
        TError,
        {data: StoriesMetaUpdateRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateStoriesMetadataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 포스팅생성API
 * @summary CreateStory
 */
export const createStory = (
    storyRegistryRequestDto: StoryRegistryRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: storyRegistryRequestDto
    },
      options);
    }
  


export const getCreateStoryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStory>>, TError,{data: StoryRegistryRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof createStory>>, TError,{data: StoryRegistryRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStory>>, {data: StoryRegistryRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createStory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateStoryMutationResult = NonNullable<Awaited<ReturnType<typeof createStory>>>
    export type CreateStoryMutationBody = StoryRegistryRequestDto
    export type CreateStoryMutationError = HTTPValidationError

    /**
 * @summary CreateStory
 */
export const useCreateStory = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStory>>, TError,{data: StoryRegistryRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof createStory>>,
        TError,
        {data: StoryRegistryRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateStoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 여러개의포스팅을한번에삭제하는API
 * @summary DeleteStories
 */
export const deleteStories = (
    params: DeleteStoriesParams,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteStoriesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStories>>, TError,{params: DeleteStoriesParams}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStories>>, TError,{params: DeleteStoriesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStories>>, {params: DeleteStoriesParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteStories(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoriesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStories>>>
    
    export type DeleteStoriesMutationError = HTTPValidationError

    /**
 * @summary DeleteStories
 */
export const useDeleteStories = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStories>>, TError,{params: DeleteStoriesParams}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteStories>>,
        TError,
        {params: DeleteStoriesParams},
        TContext
      > => {

      const mutationOptions = getDeleteStoriesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 포스팅에연관된데이터를모두제외하고,포스팅테이블에있는데이터만불러오는API
 * @summary GetOnlyStoriesNotIncludeRelationData
 */
export const getOnlyStoriesNotIncludeRelationData = (
    
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<StoriesResponseDto>(
      {url: `/stories/all`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOnlyStoriesNotIncludeRelationDataQueryKey = () => {
    return [`/stories/all`] as const;
    }

    
export const getGetOnlyStoriesNotIncludeRelationDataQueryOptions = <TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnlyStoriesNotIncludeRelationDataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>> = ({ signal }) => getOnlyStoriesNotIncludeRelationData(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnlyStoriesNotIncludeRelationDataQueryResult = NonNullable<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>>
export type GetOnlyStoriesNotIncludeRelationDataQueryError = HTTPValidationError


export function useGetOnlyStoriesNotIncludeRelationData<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOnlyStoriesNotIncludeRelationData<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOnlyStoriesNotIncludeRelationData<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetOnlyStoriesNotIncludeRelationData
 */

export function useGetOnlyStoriesNotIncludeRelationData<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOnlyStoriesNotIncludeRelationDataQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOnlyStoriesNotIncludeRelationDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnlyStoriesNotIncludeRelationDataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>> = ({ signal }) => getOnlyStoriesNotIncludeRelationData(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnlyStoriesNotIncludeRelationDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>>
export type GetOnlyStoriesNotIncludeRelationDataSuspenseQueryError = HTTPValidationError


export function useGetOnlyStoriesNotIncludeRelationDataSuspense<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOnlyStoriesNotIncludeRelationDataSuspense<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetOnlyStoriesNotIncludeRelationDataSuspense<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetOnlyStoriesNotIncludeRelationData
 */

export function useGetOnlyStoriesNotIncludeRelationDataSuspense<TData = Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError = HTTPValidationError>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOnlyStoriesNotIncludeRelationData>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOnlyStoriesNotIncludeRelationDataSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 조건에맞는포스팅의갯수를추출하는API
 * @summary GetStoriesCount
 */
export const getStoriesCount = (
    params?: GetStoriesCountParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<unknown>(
      {url: `/stories/count`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetStoriesCountQueryKey = (params?: GetStoriesCountParams,) => {
    return [`/stories/count`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStoriesCountQueryOptions = <TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(params?: GetStoriesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoriesCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoriesCount>>> = ({ signal }) => getStoriesCount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoriesCountQueryResult = NonNullable<Awaited<ReturnType<typeof getStoriesCount>>>
export type GetStoriesCountQueryError = HTTPValidationError


export function useGetStoriesCount<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params: undefined |  GetStoriesCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoriesCount>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesCount<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params?: GetStoriesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoriesCount>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesCount<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params?: GetStoriesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStoriesCount
 */

export function useGetStoriesCount<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params?: GetStoriesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoriesCountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStoriesCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(params?: GetStoriesCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoriesCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoriesCount>>> = ({ signal }) => getStoriesCount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoriesCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStoriesCount>>>
export type GetStoriesCountSuspenseQueryError = HTTPValidationError


export function useGetStoriesCountSuspense<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params: undefined |  GetStoriesCountParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesCountSuspense<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params?: GetStoriesCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesCountSuspense<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params?: GetStoriesCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStoriesCount
 */

export function useGetStoriesCountSuspense<TData = Awaited<ReturnType<typeof getStoriesCount>>, TError = HTTPValidationError>(
 params?: GetStoriesCountParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesCount>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoriesCountSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 여러개의특정한ID의포스팅들을가져오는API
 * @summary GetStoriesByIds
 */
export const getStoriesByIds = (
    params?: GetStoriesByIdsParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<StoriesResponseDto>(
      {url: `/stories/ids`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetStoriesByIdsQueryKey = (params?: GetStoriesByIdsParams,) => {
    return [`/stories/ids`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStoriesByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(params?: GetStoriesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoriesByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoriesByIds>>> = ({ signal }) => getStoriesByIds(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoriesByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getStoriesByIds>>>
export type GetStoriesByIdsQueryError = HTTPValidationError


export function useGetStoriesByIds<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params: undefined |  GetStoriesByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoriesByIds>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesByIds<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params?: GetStoriesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoriesByIds>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesByIds<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params?: GetStoriesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStoriesByIds
 */

export function useGetStoriesByIds<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params?: GetStoriesByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoriesByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStoriesByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(params?: GetStoriesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoriesByIdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoriesByIds>>> = ({ signal }) => getStoriesByIds(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoriesByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStoriesByIds>>>
export type GetStoriesByIdsSuspenseQueryError = HTTPValidationError


export function useGetStoriesByIdsSuspense<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params: undefined |  GetStoriesByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesByIdsSuspense<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params?: GetStoriesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStoriesByIdsSuspense<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params?: GetStoriesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStoriesByIds
 */

export function useGetStoriesByIdsSuspense<TData = Awaited<ReturnType<typeof getStoriesByIds>>, TError = HTTPValidationError>(
 params?: GetStoriesByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStoriesByIds>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoriesByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 포스팅결합API,합쳐진포스팅은삭제됩니다.
 * @summary ConcatStory
 */
export const concatStory = (
    concatStoryRequestDto: ConcatStoryRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/concat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: concatStoryRequestDto
    },
      options);
    }
  


export const getConcatStoryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof concatStory>>, TError,{data: ConcatStoryRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof concatStory>>, TError,{data: ConcatStoryRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof concatStory>>, {data: ConcatStoryRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  concatStory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConcatStoryMutationResult = NonNullable<Awaited<ReturnType<typeof concatStory>>>
    export type ConcatStoryMutationBody = ConcatStoryRequestDto
    export type ConcatStoryMutationError = HTTPValidationError

    /**
 * @summary ConcatStory
 */
export const useConcatStory = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof concatStory>>, TError,{data: ConcatStoryRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof concatStory>>,
        TError,
        {data: ConcatStoryRequestDto},
        TContext
      > => {

      const mutationOptions = getConcatStoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 특정포스팅을가져오는API
 * @summary GetStory
 */
export const getStory = (
    storyId: string,
    params?: GetStoryParams,
 options?: SecondParameter<typeof client>,signal?: AbortSignal
) => {
      
      
      return client<StoryResponseDto>(
      {url: `/stories/${storyId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetStoryQueryKey = (storyId: string,
    params?: GetStoryParams,) => {
    return [`/stories/${storyId}`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStoryQueryOptions = <TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoryQueryKey(storyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStory>>> = ({ signal }) => getStory(storyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(storyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStoryQueryResult = NonNullable<Awaited<ReturnType<typeof getStory>>>
export type GetStoryQueryError = HTTPValidationError


export function useGetStory<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params: undefined |  GetStoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStory>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStory<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStory>>,
          TError,
          TData
        > , 'initialData'
      >, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStory<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStory
 */

export function useGetStory<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStoryQueryOptions(storyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetStorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoryQueryKey(storyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStory>>> = ({ signal }) => getStory(storyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(storyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getStory>>>
export type GetStorySuspenseQueryError = HTTPValidationError


export function useGetStorySuspense<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params: undefined |  GetStoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStorySuspense<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
export function useGetStorySuspense<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey }
/**
 * @summary GetStory
 */

export function useGetStorySuspense<TData = Awaited<ReturnType<typeof getStory>>, TError = HTTPValidationError>(
 storyId: string,
    params?: GetStoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getStory>>, TError, TData>>, request?: SecondParameter<typeof client>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorySuspenseQueryOptions(storyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 포스팅수정API
 * @summary UpdateStory
 */
export const updateStory = (
    storyId: string,
    storyUpdateRequestDto: StoryUpdateRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/${storyId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: storyUpdateRequestDto
    },
      options);
    }
  


export const getUpdateStoryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStory>>, TError,{storyId: string;data: StoryUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStory>>, TError,{storyId: string;data: StoryUpdateRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStory>>, {storyId: string;data: StoryUpdateRequestDto}> = (props) => {
          const {storyId,data} = props ?? {};

          return  updateStory(storyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateStory>>>
    export type UpdateStoryMutationBody = StoryUpdateRequestDto
    export type UpdateStoryMutationError = HTTPValidationError

    /**
 * @summary UpdateStory
 */
export const useUpdateStory = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStory>>, TError,{storyId: string;data: StoryUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateStory>>,
        TError,
        {storyId: string;data: StoryUpdateRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateStoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 포스팅삭제API
 * @summary DeleteStory
 */
export const deleteStory = (
    storyId: string,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/${storyId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteStoryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStory>>, TError,{storyId: string}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStory>>, TError,{storyId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStory>>, {storyId: string}> = (props) => {
          const {storyId} = props ?? {};

          return  deleteStory(storyId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStory>>>
    
    export type DeleteStoryMutationError = HTTPValidationError

    /**
 * @summary DeleteStory
 */
export const useDeleteStory = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStory>>, TError,{storyId: string}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteStory>>,
        TError,
        {storyId: string},
        TContext
      > => {

      const mutationOptions = getDeleteStoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 스토리메타데이터업데이트
 * @summary UpdateStoryMetadata
 */
export const updateStoryMetadata = (
    storyId: string,
    storyMetaUpdateRequestDto: StoryMetaUpdateRequestDto,
 options?: SecondParameter<typeof client>,) => {
      
      
      return client<CommonResponseDto>(
      {url: `/stories/${storyId}/meta`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: storyMetaUpdateRequestDto
    },
      options);
    }
  


export const getUpdateStoryMetadataMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryMetadata>>, TError,{storyId: string;data: StoryMetaUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoryMetadata>>, TError,{storyId: string;data: StoryMetaUpdateRequestDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoryMetadata>>, {storyId: string;data: StoryMetaUpdateRequestDto}> = (props) => {
          const {storyId,data} = props ?? {};

          return  updateStoryMetadata(storyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoryMetadataMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoryMetadata>>>
    export type UpdateStoryMetadataMutationBody = StoryMetaUpdateRequestDto
    export type UpdateStoryMetadataMutationError = HTTPValidationError

    /**
 * @summary UpdateStoryMetadata
 */
export const useUpdateStoryMetadata = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoryMetadata>>, TError,{storyId: string;data: StoryMetaUpdateRequestDto}, TContext>, request?: SecondParameter<typeof client>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateStoryMetadata>>,
        TError,
        {storyId: string;data: StoryMetaUpdateRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateStoryMetadataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    